import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgMagnifyingGlassIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22.4 9.6c-7.069 0-12.8 5.73-12.8 12.8s5.731 12.8 12.8 12.8c3.536 0 6.733-1.431 9.051-3.749a12.76 12.76 0 0 0 3.75-9.051c0-7.07-5.731-12.8-12.8-12.8m-16 12.8c0-8.836 7.164-16 16-16s16 7.163 16 16a15.94 15.94 0 0 1-3.61 10.126l3.61 3.611.938-.937a3.2 3.2 0 0 1 4.525 0L57.6 48.937a3.2 3.2 0 0 1 0 4.526L53.463 57.6a3.2 3.2 0 0 1-4.525 0L35.2 43.863a3.2 3.2 0 0 1 0-4.526l.938-.937-3.612-3.611A15.94 15.94 0 0 1 22.4 38.4c-8.836 0-16-7.163-16-16m35.2 15.063L37.463 41.6 51.2 55.337l4.138-4.137z"
    />
  </svg>
)
export default SvgMagnifyingGlassIcon
